import styled from 'styled-components';

export const ContainerItem = styled.div`
  background: transparent;
  border: 1px solid #EEE; 
  border-radius: 4px; 
  width: 100%; 
  padding: 20px; 
  margin: 0 0 10px 0; 
  height: 80px; 
  display: flex; 
  flex-direction: row; 

  ${({ checked }) => checked && `
    border: 1px solid #F07E31; 
  `}
  ${({ error }) => error && `
    border: 1px solid #D83430; 
  `}
`;

export const ImageProfile = styled.img`
  margin:-7px 10px 0 0;
  width: 30px;
  height: 30px;
  clip-path: circle(50%);
`;

export const TextInf = styled.p`
  color: #F07E31 !important;
  font-weight: bold !important;  
  text-align: ${props => props.hAlign} !important;
`;

export const RatingRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: -5px auto;
`;

export const Business = styled.p`
  color: #BCBCBC !important;
  font-size: 11px !important;
  text-align: left !important;
  margin-top:-5px;
`;

export const FlexProp = styled.div`
  flex: ${props => props.proportion}
`;

export const DisplayRow = styled.div`
  display: flex; 
  flex-direction: row; 
  flex: ${props => props.proportion}
`;